import { getRecordingURL } from '@/utils/logrocketInit'
import { replaceCompanySlugPlaceholder } from '@/utils/currentCompanySlug'
import type { InternalAxiosRequestConfig } from 'axios'

type RequestConfig = InternalAxiosRequestConfig & {
  ignoreGlobalAuthTokenSet?: boolean
}

// Request context shared by every axios client (httpClient, vaiClient): the
// current company slug in the URL, the auth token and the LogRocket session.
export const applyRequestContext = <T extends RequestConfig>(config: T): T => {
  if (config.url) {
    config.url = replaceCompanySlugPlaceholder(config.url)
  }

  const token = localStorage.getItem('token')
  if (token && !config.ignoreGlobalAuthTokenSet) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const sessionURL = getRecordingURL()
  if (sessionURL) {
    config.headers['X-LogRocket-URL'] = sessionURL
  }

  return config
}
